import React, { Suspense } from 'react';
import { Lazy } from '@root/src/web/components/Lazy';
import { initPerf } from '@root/src/web/browser/initPerf';
const SignInGateMain = React.lazy(() => {
    const { start, end } = initPerf('SignInGateMain');
    start();
    return import(
    /* webpackChunkName: "SignInGateMain" */ '../gateDesigns/SignInGateMain').then((module) => {
        end();
        return { default: module.SignInGateMain };
    });
});
export const signInGateComponent = (canShow) => {
    const gateComponent = {
        gate: ({ ophanComponentId, dismissGate, guUrl, signInUrl, abTest, isComment, }) => (React.createElement(Lazy, { margin: 300 },
            React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
                React.createElement(SignInGateMain, { ophanComponentId: ophanComponentId, dismissGate: dismissGate, guUrl: guUrl, signInUrl: signInUrl, abTest: abTest, isComment: isComment })))),
        canShow,
    };
    return gateComponent;
};
